/**
 * PluginMarketplaceWrapper Component
 * Wrapper for Plugin Marketplace modal
 */

import React from 'react';
import { PluginMarketplace } from '../plugins';
import { toast } from 'sonner';

export const PluginMarketplaceWrapper = ({
  isOpen,
  onClose,
  installedPlugins = [],
}) => {
  return (
    <PluginMarketplace
      isOpen={isOpen}
      onClose={onClose}
      onInstallPlugin={(plugin) => {
        toast.success(`${plugin.name} installed!`);
        // In production, would add to available plugins list
      }}
      installedPlugins={installedPlugins}
    />
  );
};

export default PluginMarketplaceWrapper;
